import { getTimestampFromDateTime } from "../../../helpers/formatDate"
import { ASSET_ACTIVITY_STATUS_OPTIONS } from "../../constants/assetActivitiesStatus"
import AssetTable from "./AssetTable"

export default function ActivitiesTable({ data, showModel }) {
  const columns = [
    { header: "FECHA Y HORA", render: (m) => getTimestampFromDateTime(m.report_date) || "N/A" },
    { header: "USUARIO", render: (m) => `${m.user_uid || "-"} - ${m.user_full_name || "-"}` },
    { header: "NOMBRE DE CLIENTE", render: (m) => `${m.client_uid || "-"} - ${m.client_name || "-"}` },
    { header: "# DE DOCUMENTO", render: (m) => m.uid || "-" },
    { header: "TIPO DE REPORTE", render: (m) => m.asset_report_title || "-" },
    { 
      header: "ESTADO", 
      render: (m) => {
        const option = ASSET_ACTIVITY_STATUS_OPTIONS[m.status]
        return option ? <div className={option.className}>{option.label}</div> : "-"
      } 
    }
  ]

  return (
    <AssetTable
      data={data}
      showModel={showModel}
      columns={columns}
      emptyMessage="No hay reportes de activos en este momento."
      statusOptions={ASSET_ACTIVITY_STATUS_OPTIONS}
    />
  )
}
